import { render, staticRenderFns } from "./formdatelimit.vue?vue&type=template&id=09cc50d9"
import script from "./formdatelimit.vue?vue&type=script&lang=js"
export * from "./formdatelimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports